import {httpService} from '@/modules/core/services/http-service';
import {Diabetesteam} from "@/modules/diabetesteam/domains";

export async function getAlleDiabetesteams(): Promise<Diabetesteam[]> {
    const response = await httpService.get<any>(`/online-registratie/api/diabetesteam/all?sort=naam`)
    return response
        .map((diabeticTeamData: any) => new Diabetesteam(diabeticTeamData))
}
